<template>
  <AnalysisRequests
    :siteId="site.id"
    @onTemplate="openTemplateModal"
  />
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import AnalysisRequests from '@/views/laboratory/AnalysisRequests.vue';
import Template from './templateAnalysisRequest.vue';

export default {
    components: {
        AnalysisRequests,
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    methods: {
        openTemplateModal() {
            this.$root.$emit('showModal', {
                showNextPrevious: false,
                showConfirmButton: false,
                showTabNavigations: false,
                title: this.$t('analysisRequests.template'),
                component: Vue.component('Template', Template),
                payload: { isTemplate: true },
                onConfirm: requestPayload => {
                    this.addAnalysisRequest(requestPayload);
                },
            });
        },
    },
};
</script>
